var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M30.095 18.77c.439.172.655.67.482 1.11-2.195 5.627-7.497 9.263-13.504 9.263-7.888 0-14.313-6.356-14.495-14.233l-1.12 1.125a.852.852 0 0 1-1.208 0 .859.859 0 0 1 0-1.212l2.414-2.425a.852.852 0 0 1 1.207 0l2.415 2.425a.859.859 0 0 1 0 1.212.853.853 0 0 1-1.208 0l-.776-.78c.358 6.771 5.94 12.174 12.771 12.174 5.3 0 9.978-3.21 11.916-8.175a.852.852 0 0 1 1.106-.485zm3.801-5.662a.859.859 0 0 1 0 1.212l-2.414 2.425a.853.853 0 0 1-1.208 0L27.86 14.32a.859.859 0 0 1 0-1.212.85.85 0 0 1 1.207 0l.777.78c-.358-6.771-5.94-12.174-12.77-12.174-5.302 0-9.98 3.209-11.916 8.175a.853.853 0 1 1-1.589-.626C5.764 3.636 11.064 0 17.073 0c7.889 0 14.314 6.356 14.495 14.234l1.121-1.126a.85.85 0 0 1 1.207 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(45 15.293 13.086)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M-4.269-4.286h42.684V33.43H-4.27z",
    mask: "url(#b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.1f0a0d3a.svg";
export { ForwardRef as ReactComponent };